import { render, staticRenderFns } from "./Frequency.vue?vue&type=template&id=ffb06fe6&scoped=true&"
import script from "./Frequency.vue?vue&type=script&lang=js&"
export * from "./Frequency.vue?vue&type=script&lang=js&"
import style0 from "./Frequency.vue?vue&type=style&index=0&id=ffb06fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb06fe6",
  null
  
)

export default component.exports